<template>
    <el-select
        ref="selectTreeBox"
        :value="valueTitle"
        :clearable="clearable"
        @clear="clearHandle"
        :placeholder="placeholder"
        :disabled="disabled"
    >
        <el-option :value="valueTitle" :label="valueTitle">
            <el-tree
                id="tree-option"
                ref="selectTree"
                default-expand-all
                :expand-on-click-node="false"
                :data="options"
                :props="props"
                :current-node-key="valueId"
                :node-key="props.value"
                @node-click="handleNodeClick"
            ></el-tree>
        </el-option>
    </el-select>
</template>

<script>
export default {
    name: 'el-tree-select',
    props: {
        // 配置项
        props: {
            type: Object,
            default: () => {
                return {
                    value: 'id', // ID字段名
                    label: 'title', // 显示名称
                    children: 'childrenData', // 子级字段名
                }
            },
        },
        // 是否禁选
        disabled: {
            type: Boolean,
            default: false,
        },
        //选项列表数据(树形结构的对象数组)
        options: {
            type: Array,
            default: [],
        },
        //初始值
        value: {
            type: Number,
            default: 0,
        },
        //可清空选项
        clearable: {
            type: Boolean,
            default: true,
        },
        //placeholder
        placeholder: {
            type: String,
            default: '请选择',
        },
    },
    data() {
        return {
            valueId: this.value, // 初始值
            valueTitle: '',
        }
    },
    mounted() {
        this.initHandle()
    },
    methods: {
        // 初始化值
        initHandle() {
            this.initScroll()
            if (this.valueId === -1) return
            this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[
                this.props.label
            ]
            this.$nextTick(function() {
                this.$refs.selectTree.setCurrentKey(this.valueId)
            })
        },
        // 初始化滚动条
        initScroll() {
            this.$nextTick(() => {
                let scrollWrap = document.querySelectorAll(
                    '.el-scrollbar .el-select-dropdown__wrap'
                )[0]
                let scrollBar = document.querySelectorAll(
                    '.el-scrollbar .el-scrollbar__bar'
                )
                scrollWrap.style.cssText =
                    'margin: 0px; max-height: none; overflow: hidden;'
                scrollBar.forEach((ele) => (ele.style.width = 0))
            })
        },
        // 切换选项
        handleNodeClick(node) {
            this.$refs.selectTreeBox.blur()
            this.valueTitle = node[this.props.label]
            this.valueId = node[this.props.value]
            this.$emit('callBackSelect', this.valueId)
        },
        //清除选中
        clearHandle() {
            this.valueTitle = ''
            this.valueId = -1
            this.clearSelected()
            this.$emit('callBackSelect', -1)
        },
        // 清空选中样式
        clearSelected() {
            let allNode = document.querySelectorAll(
                '#tree-option .el-tree-node'
            )
            allNode.forEach((element) => element.classList.remove('is-current'))
        },
    },
    watch: {
        value() {
            this.valueId = this.value
            this.valueTitle = ''
            this.initHandle()
        },
    },
}
</script>

<style scoped>
.el-select-dropdown__item {
    height: auto;
    max-height: 274px;
    padding: 0;
    overflow-y: auto;
}
.el-select-dropdown__item.selected {
    font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
    height: auto;
    padding: 0 20px;
    background: none !important;
}
.el-tree-node__label {
    font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
    color: #409eff;
    font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
    color: #606266;
    font-weight: normal;
}
</style>
